import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router'
import {mdiFilePdfBox, mdiMagnify, mdiMicrosoftExcel  } from '@mdi/js'
import { useDispatch } from 'react-redux'
import './styles.scss'
import { useAppSelector } from '../../../../store/hooks'
import Section, { SectionBox, SectionOption } from '../../../../components/Section'
import getIndustriaMonitorada from './scripts/getIndustriaMonitorada' 
import TableListarIndustriasMonitoradas from './Components/TableListarIndustriasMonitoradas'
import { Link } from 'react-router-dom'
import { TextField } from '@material-ui/core'
import {setAnoInicial, setAnoFinal } from './Reducers/MonitoramentoReducer'
import filter from './scripts/filter'
import { ExcelIndustriaMonitorada } from '../../../../scripts/ExcelIndustriaMonitorada'
import isEditable from '../../../../scripts/modules/isEditable'

const IndustriasMonitoradas: React.FC = () => {    

    const { idCliente } = useParams<any>()
    const dispatch = useDispatch()
    const {anoInicial, anoFinal, requestFilter, historicoColeta } = useAppSelector(state => state.MonitoramentoReducer)

    useEffect(() => {
        getIndustriaMonitorada(dispatch, Number(idCliente), 1)
    }, [dispatch, idCliente])

    const handleFilter = useCallback(async () => {
        await filter(dispatch, { dtInicio:anoInicial , dtFim: anoFinal})
    }, [dispatch,anoInicial, anoFinal ])

        const { accessAuthorizedModules } = useAppSelector(state => state.modules)
    const canEdit = isEditable(accessAuthorizedModules, 'industria-monitorada')

    return(
        <> 
            <Section name = "data">
                <SectionBox 
                    title = {`010_FMEI_Ind.Monitoradas`} 
                    goBack
                    padding = {false}
                    right={
                        <>
                            <TextField type="date" id="filterAnoInicial" variant="standard" className="fieldFilter" placeholder="Cliente" value={anoInicial} onChange={e => dispatch(setAnoInicial(e.target.value))}/>
                            <TextField type="date" id="filterAnoFinal" variant="standard" className="fieldFilter" placeholder="Cliente" value={anoFinal} onChange={e => dispatch(setAnoFinal(e.target.value))}/>
                            
                            <SectionOption icon = {mdiMagnify} tooltip = "Filtrar" onClick = {handleFilter} />
                            {canEdit && <Link to = "pdf" target = "_blank">
                                <SectionOption icon = {mdiFilePdfBox} tooltip = "Visualizar PDF" onClick = {() => {}} />
                            </Link>}
                            <SectionOption icon = {mdiMicrosoftExcel} tooltip = "Baixar Excel" onClick = {() => {ExcelIndustriaMonitorada(historicoColeta)}} />
                        </>
                    }
                >
                    <TableListarIndustriasMonitoradas 
                        id = {Number(idCliente)}
                        lista = { historicoColeta} 
                        loading = {requestFilter.loading} 
                    />
                </SectionBox>
            </Section>
        </>
    )

}

export default IndustriasMonitoradas